module.exports = __webpack_public_path__ + "img/m1.73f9047b.png";